import {Link} from 'react-router'

import {getCrossProductLinks} from '@core/products/cross-links'
import {narcisConfig} from '@product/narcis/config'
import styles from './Footer.module.scss'

const siblingProducts = getCrossProductLinks('narcis')

const Footer = () => {
    return (
        <footer className={styles.footer}>
            {/* Top row — 5-column grid */}
            <div className={styles.topRow}>
                {/* Brand column */}
                <div className={styles.brandCol}>
                    <Link to="/" className={styles.brandLink}>
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 64 64"
                            fill="none"
                            aria-hidden="true"
                            className={styles.mark}
                        >
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9"/>
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(60 32 32)"/>
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(120 32 32)"/>
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(180 32 32)"/>
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(240 32 32)"/>
                            <ellipse cx="32" cy="14" rx="6.5" ry="14" fill="#FAFAF9" transform="rotate(300 32 32)"/>
                            <circle cx="32" cy="32" r="9" fill="#E8C24A"/>
                            <circle cx="32" cy="32" r="9" fill="none" stroke="#FAFAF9" strokeWidth="0.8"/>
                        </svg>
                        <span className={styles.wordmark}>Narcis</span>
                    </Link>
                    <p className={styles.tagline}>AI portraits, honestly.</p>
                    <div className={styles.statusRow}>
                        <span className={styles.statusDot} aria-label="All systems operational"/>
                        <span className={styles.statusLabel}>All systems operational</span>
                    </div>
                </div>

                {/* Make column */}
                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Make</span>
                    <Link to="/tools" className={styles.link}>Free tools</Link>
                    <Link to="/tools/swap" className={styles.link}>Free face swap</Link>
                    {/* "Portrait studio" link removed 2026-07-25 (DEVIATIONS.md #77) — the
                        free-form composer it pointed at is retired. The per-pack link list
                        removed 2026-08-10 (operator): the catalog outgrew a footer column;
                        "Packs" in the Buy column is the door to the hub. */}
                </div>

                {/* Buy column */}
                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Buy</span>
                    <Link to="/pricing" className={styles.link}>Pricing</Link>
                    <Link to="/packs" className={styles.link}>Packs</Link>
                    <Link to="/terms" className={styles.link}>Refund policy</Link>
                </div>

                {/* Trust column */}
                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Trust</span>
                    <Link to="/terms#acceptable-use" className={styles.link}>Acceptable use</Link>
                    <Link to="/terms" className={styles.link}>Terms</Link>
                    <Link to="/terms#ncii-policy" className={styles.link}>NCII policy</Link>
                </div>

                {/* Company column */}
                <div className={styles.linkCol}>
                    <span className={styles.colHeading}>Company</span>
                    <a href={`mailto:${narcisConfig.contact.email}`} className={styles.link}>Contact</a>
                    {siblingProducts.map((p) => (
                        <a
                            key={p.id}
                            href={p.url}
                            target="_blank"
                            rel="noopener"
                            className={styles.link}
                        >
                            {p.name}
                        </a>
                    ))}
                </div>
            </div>

            {/* Separator */}
            <div className={styles.separator} aria-hidden="true"/>

            {/* Bottom row */}
            <div className={styles.bottomRow}>
                <div className={styles.bottomLeft}>
                    <span className={styles.copyright}>
                        &copy; 2026 Narcis SAS &mdash; Paris
                    </span>
                    <span className={styles.version}>v{narcisConfig.version}</span>
                </div>
                <div className={styles.bottomRight}>
                    <a href="#" className={styles.socialLink} aria-label="Twitter/X">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M4 4l6.5 8L4 20h2l5.5-6.8L16 20h4l-7-8.5L19.5 4h-2L12.5 10 8 4H4z"/>
                        </svg>
                    </a>
                    <a href="#" className={styles.socialLink} aria-label="Instagram">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="2" y="2" width="20" height="20" rx="5"/>
                            <circle cx="12" cy="12" r="5"/>
                            <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/>
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export {Footer}
